import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { Decorative } from "@faire/design-tokens";
import { getShouldUseZendeskSandbox } from "@faire/help-center-utils/serialized-data/getShouldUseZendeskSandbox";
import { getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment } from "@faire/help-center-utils/settings/getSettingHelpCenterSearchAndNavImprovements";
import { backwardsCompatibleValues } from "@faire/web/common/localization/localize";
export var TABLET_GUTTER_SIZE = getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment() ? 24 : 40;
export var DESKTOP_GUTTER_SIZE = 56;
export var isHiddenSection = function isHiddenSection(sectionId) {
  if (!sectionId) {
    return false;
  }
  var BRAND_HIDDEN_SECTION_ID = getShouldUseZendeskSandbox() ? 14638005358107 : 360009975811;
  var RETAILER_HIDDEN_SECTION_ID = getShouldUseZendeskSandbox() ? 14638190793371 : 360012034032;
  return [BRAND_HIDDEN_SECTION_ID, RETAILER_HIDDEN_SECTION_ID].includes(sectionId);
};
export var BRANDS_BANNER_DATA = function BRANDS_BANNER_DATA(strictLocalize) {
  return {
    color: Decorative.shade.green,
    title: strictLocalize({
      id: "wepRv9",
      defaultMessage: [{
        "type": 0,
        "value": "Vendre sur Faire"
      }]
    }),
    copy: strictLocalize({
      id: "7fcD9E",
      defaultMessage: [{
        "type": 0,
        "value": "Plus d'informations sur l'expédition des commandes, les communications avec les commerçants, les versements, etc."
      }]
    }),
    imageURL: "https://cdn.faire.com/fastly/66c67dbccc5b62714fbd3e0062a9a1781085987a5c03ab2e50513ffa6b59795d.jpeg"
  };
};
export var RETAILERS_BANNER_DATA = function RETAILERS_BANNER_DATA(strictLocalize) {
  return {
    color: Decorative.icon.orange,
    title: strictLocalize({
      id: "y17ukl",
      defaultMessage: [{
        "type": 0,
        "value": "Acheter sur Faire"
      }]
    }),
    copy: strictLocalize({
      id: "IBrdd/",
      defaultMessage: [{
        "type": 0,
        "value": "Découvrez comment modifier des commandes, communiquer avec les marques, signaler des problèmes et bien plus encore."
      }]
    }),
    imageURL: "https://cdn.faire.com/fastly/1a6b2136cbfe83154ba3615b8871d38c49e8e3426601a573f66d10137dca62c9.jpeg"
  };
};
export var READ_MORE = function READ_MORE(strictLocalize) {
  return strictLocalize({
    id: "ZSXXNS",
    defaultMessage: [{
      "type": 0,
      "value": "En savoir plus"
    }]
  });
};
export var IN_THIS_GUIDE = function IN_THIS_GUIDE(strictLocalize) {
  return strictLocalize({
    id: "jcnWnm",
    defaultMessage: [{
      "type": 0,
      "value": "Dans ce guide"
    }]
  });
};
export var BROWSE_ALL_TOPICS = function BROWSE_ALL_TOPICS(strictLocalize) {
  return strictLocalize({
    id: "XtlHWT",
    defaultMessage: [{
      "type": 0,
      "value": "Parcourir tous les sujets"
    }]
  });
};
export var QUICK_ACTIONS = function QUICK_ACTIONS(strictLocalize) {
  return strictLocalize({
    id: "EeT1Ty",
    defaultMessage: [{
      "type": 0,
      "value": "Actions rapides"
    }]
  });
};
export var viewAllText = function viewAllText(totalNumber, strictLocalize) {
  return strictLocalize({
    id: "EjKrRq",
    defaultMessage: [{
      "type": 0,
      "value": "Voir tout ("
    }, {
      "type": 1,
      "value": "totalNumber"
    }, {
      "type": 0,
      "value": ")"
    }]
  }, backwardsCompatibleValues({
    totalNumber: totalNumber
  }));
};